import { parseLocalDate, premier } from '../domain/schedule';

export { premier };

const cap = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

/** « Mercredi 28 octobre » (+ « Aujourd'hui » / « Demain »). */
export function dayLabel(date: string, today: string, tomorrow: string): string {
  if (date === today) return "Aujourd'hui";
  if (date === tomorrow) return 'Demain';
  return cap(premier(parseLocalDate(date).toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' })));
}

export const longDate = (date: string) =>
  cap(premier(parseLocalDate(date).toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })));

/** « 1er déc. », « 12 déc. » */
export const shortDate = (date: string) =>
  premier(parseLocalDate(date).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' }));

/** « 9h00 », « 20h30 » : l'heure, partout dans l'app (B18 : plus de « 09h00 »). */
export const time = (d: Date) => `${d.getHours()}h${String(d.getMinutes()).padStart(2, '0')}`;

/** « dimanche 1er novembre à 15h30 » : une date et son heure, comme partout dans l'app (B17). */
export const dateTime = (d: Date) => `${premier(d.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' }))} à ${time(d)}`;

export const timeRange = (start: Date, end: Date | null) => (end ? `${time(start)} – ${time(end)}` : time(start));

export const KIND_LABEL = { training: 'Entraînement', match: 'Match', other: 'Événement' } as const;
